// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL NLP API - Public
 * Writing Legends NLP API Service - Public Endpoints
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  HTTPValidationError,
  TextStatsRequest,
  VerifyTextResponse,
} from '../models/index'
import {
  HTTPValidationErrorFromJSON,
  HTTPValidationErrorToJSON,
  TextStatsRequestFromJSON,
  TextStatsRequestToJSON,
  VerifyTextResponseFromJSON,
  VerifyTextResponseToJSON,
} from '../models/index'

export interface ExtractTerrificAlternativesTerrificAlternativesPostRequest {
  textStatsRequest: TextStatsRequest
}

export interface VerifyTextVerifyTextPostRequest {
  textStatsRequest: TextStatsRequest
}

export interface VerifyTextsVerifyTextsPostRequest {
  textStatsRequest: Array<TextStatsRequest>
}

/**
 *
 */
export class ExcitingWritingIdeasApi extends runtime.BaseAPI {
  /**
   * Extract Terrific Alternatives
   */
  async extractTerrificAlternativesTerrificAlternativesPostRaw(
    requestParameters: ExtractTerrificAlternativesTerrificAlternativesPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<{ [key: string]: Array<string> }>> {
    if (
      requestParameters.textStatsRequest === null ||
      requestParameters.textStatsRequest === undefined
    ) {
      throw new runtime.RequiredError(
        'textStatsRequest',
        'Required parameter requestParameters.textStatsRequest was null or undefined when calling extractTerrificAlternativesTerrificAlternativesPost.',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('HTTPBearer', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/terrific_alternatives`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: TextStatsRequestToJSON(requestParameters.textStatsRequest),
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse<any>(response)
  }

  /**
   * Extract Terrific Alternatives
   */
  async extractTerrificAlternativesTerrificAlternativesPost(
    requestParameters: ExtractTerrificAlternativesTerrificAlternativesPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<{ [key: string]: Array<string> }> {
    const response =
      await this.extractTerrificAlternativesTerrificAlternativesPostRaw(
        requestParameters,
        initOverrides,
      )
    return await response.value()
  }

  /**
   * Verify Text
   */
  async verifyTextVerifyTextPostRaw(
    requestParameters: VerifyTextVerifyTextPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<VerifyTextResponse>> {
    if (
      requestParameters.textStatsRequest === null ||
      requestParameters.textStatsRequest === undefined
    ) {
      throw new runtime.RequiredError(
        'textStatsRequest',
        'Required parameter requestParameters.textStatsRequest was null or undefined when calling verifyTextVerifyTextPost.',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('HTTPBearer', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/verify_text`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: TextStatsRequestToJSON(requestParameters.textStatsRequest),
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      VerifyTextResponseFromJSON(jsonValue),
    )
  }

  /**
   * Verify Text
   */
  async verifyTextVerifyTextPost(
    requestParameters: VerifyTextVerifyTextPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<VerifyTextResponse> {
    const response = await this.verifyTextVerifyTextPostRaw(
      requestParameters,
      initOverrides,
    )
    return await response.value()
  }

  /**
   * Verify Texts
   */
  async verifyTextsVerifyTextsPostRaw(
    requestParameters: VerifyTextsVerifyTextsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<VerifyTextResponse>>> {
    if (
      requestParameters.textStatsRequest === null ||
      requestParameters.textStatsRequest === undefined
    ) {
      throw new runtime.RequiredError(
        'textStatsRequest',
        'Required parameter requestParameters.textStatsRequest was null or undefined when calling verifyTextsVerifyTextsPost.',
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('HTTPBearer', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/verify_texts`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters.textStatsRequest.map(TextStatsRequestToJSON),
      },
      initOverrides,
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(VerifyTextResponseFromJSON),
    )
  }

  /**
   * Verify Texts
   */
  async verifyTextsVerifyTextsPost(
    requestParameters: VerifyTextsVerifyTextsPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<VerifyTextResponse>> {
    const response = await this.verifyTextsVerifyTextsPostRaw(
      requestParameters,
      initOverrides,
    )
    return await response.value()
  }
}
